import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const InitializeHeroBannerSwiper = () => {
    const HBCBlocks = document.querySelectorAll('.hero-banner-carousel-block');
    HBCBlocks.forEach(HBCBlock => {
        const hbcSwiper = HBCBlock.querySelector('.swiper-hbc');
        const hbcSwiperWrapper = hbcSwiper ? hbcSwiper.querySelector('.swiper-wrapper') : null;

        if (hbcSwiperWrapper) {
            const swiperSlides = hbcSwiperWrapper.querySelectorAll('.swiper-slide');

            if (swiperSlides.length < 2) {
                // less than two slide, hide thumbnail
                hbcSwiper?.classList.add('one-slide');
            } else {
                // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
                const heroBannerSwiper = new Swiper('.swiper-hbc', {
                    spaceBetween: 24,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    speed: 500,
                    navigation: {
                        nextEl: '.swiper-hbc-button-next',
                        prevEl: '.swiper-hbc-button-prev'
                    },
                    autoHeight: true,
                    loop: true,
                    pagination: {
                        el: '.swiper-hbc-pagination',
                        clickable: true
                    },
                    autoplay: { delay: 7000, disableOnInteraction: false }
                });
            }
        }
    });
};

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', InitializeHeroBannerSwiper);
